import React, { useState, useEffect } from 'react';
import classes from './GroupsFilterDropdown.module.css';
import filtersIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters2.png';

const Pills = ({ options, selected, onToggle }) => (
    <div className={classes.pills}>
        {options.map(opt => (
            <button
                key={opt}
                type="button"
                className={`${classes.pill} ${selected.includes(opt) ? classes.pillActive : ''}`}
                onClick={() => onToggle(opt)}
            >
                {opt}
            </button>
        ))}
    </div>
);

// fields: [{ key, label }] - only columns currently visible in the table should be passed in
// filters: { [key]: 0 | 1 | 2 } - 0 = no filter, 1 = has, 2 = doesn't have
const GroupsFilterDropdown = ({ fields, filters, onApply }) => {
    const [showFilters, setShowFilters] = useState(false);
    const [localFilters, setLocalFilters] = useState(filters);

    useEffect(() => {
        setLocalFilters(filters);
    }, [filters]);

    const toggleField = (key, mode) => {
        setLocalFilters(prev => ({
            ...prev,
            [key]: prev[key] === mode ? 0 : mode,
        }));
    };

    const handleApply = () => {
        onApply(localFilters);
        setShowFilters(false);
    };

    const handleReset = () => {
        const cleared = Object.fromEntries(fields.map(f => [f.key, 0]));
        setLocalFilters(cleared);
        onApply(cleared);
        setShowFilters(false);
    };

    const activeCount = Object.values(filters).filter(v => v !== 0).length;

    const activeChips = fields
        .map(({ key, label }) => {
            if (filters[key] === 1) return { key, label: `Has ${label}` };
            if (filters[key] === 2) return { key, label: `No ${label}` };
            return null;
        })
        .filter(Boolean);

    const clearChip = (key) => onApply({ ...filters, [key]: 0 });

    return (
        <div className={classes.wrapper}>
            <button className={classes.filterButton} type="button" onClick={() => setShowFilters(p => !p)}>
                <img style={{ height: 30, width: 30 }} src={filtersIcon} alt="Filters" />
                {activeCount > 0 && <span className={classes.badge}>{activeCount}</span>}
            </button>

            {showFilters && (
                <div className={classes.panel}>
                    <div className={classes.panelHeader}>
                        <span className={classes.panelTitle}>Filters</span>
                        <div className={classes.panelActions}>
                            <button className={classes.resetBtn} type="button" onClick={handleReset}>Reset</button>
                            <button className={classes.applyBtn} type="button" onClick={handleApply}>Apply</button>
                        </div>
                    </div>
                    <div className={classes.panelBody}>
                        {fields.map(({ key, label }) => (
                            <div className={classes.fieldRow} key={key}>
                                <span className={classes.fieldLabel}>{label}</span>
                                <Pills
                                    options={['Has', "Doesn't have"]}
                                    selected={localFilters[key] === 1 ? ['Has'] : localFilters[key] === 2 ? ["Doesn't have"] : []}
                                    onToggle={(opt) => toggleField(key, opt === 'Has' ? 1 : 2)}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {activeChips.length > 0 && (
                <div className={classes.activeFilters}>
                    {activeChips.map(({ key, label }) => (
                        <span key={key} className={classes.filterChip}>
                            {label}
                            <button className={classes.filterChipClear} onClick={() => clearChip(key)} type="button">×</button>
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GroupsFilterDropdown;
